import { Badge as MuiBadge } from "@mui/material";
import React, { ReactElement } from "react";

interface Props {
  badgeNumber?: number;
  children: ReactElement;
  color?: string;
}

const Badge: React.FC<Props> = (props) => {
  const { badgeNumber, children, color } = props;
  return (
    <MuiBadge
      badgeContent={badgeNumber}
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: color,
          color: "white",
          top: 15,
          right: -15,
        },
      }}
    >
      {children}
    </MuiBadge>
  );
};

export default Badge;
